// import ReactGA from "react-ga4";

let resolveSession;
const currentSession = {
  session: null,
  activeUser: null,
};
const sessionPromise = new Promise((resolve) => {
  resolveSession = resolve;
});

export const initSession = (session, activeUser) => {
  currentSession.session = session;
  currentSession.activeUser = activeUser;
  if (session) resolveSession(currentSession);
};


const sendEvent = async (eventName, params = {}) => {
  const _currentSession = await sessionPromise;
  const { activeUser, session } = _currentSession;

  const type = activeUser
    ? "patient_in_fono"
    : session?.my_user?.typeUser || "";

  const profile = activeUser
    ? ""
    : session?.my_user?.profile || "";

  const user_id = session?.sub || "";

  // 🔹 Verifica se existe algum parâmetro vazio ("", null, undefined ou só espaços)
  const hasEmptyParam = Object.entries(params).some(([key, value]) => {
    return (
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "")
    );
  });

  if (hasEmptyParam) {
    console.warn(
      `Evento bloqueado (${eventName}): contém parâmetro vazio`,
      params
    );
    return; // 🚫 não envia o evento
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    user_type: type,
    profile: profile,
    user_id: user_id,
    ...params,
  });

  console.log(`Datalayer Event: ${eventName}`, {
    ...params,
    user_type: type,
    profile,
  });
};


// ======================
// Eventos refatorados
// ======================

/**
 * @param {String} type 
 * O tipo do filtro que o usuario clicou.
 * @param {String} value
 * O valor que está sendo filtrado
 * @param {Booleano} status
 * Indica se ele foi mudado para ativo ou inativo. 
 */
export const setAnalyticsFilterByType = ( {type,value,status}) =>
  sendEvent("activities_filter", { type, value, status });

/**
 * @param {String} name
 * Nome do jogo aberto
 * @param {Number} id
 * Id do jogo aberto
 */
export const setAnalyticsPlayGame = ({ name, id }) =>
  sendEvent("play_game", { game_name: name, game_id: id });

/**
 * @param {String} name
 * Nome do audio 
 * @param {Number} id
 * Id do audio
 */
export const setAnalyticsPlayAudio = ({ name, id }) =>
  sendEvent("play_audio", { audio_name: name, audio_id: id });

// Apenas Dashboard Legado, caso o usuario clique para reativar a assinatura ou fechar o modal de recorrência
export const setAnalyticsModalRecurrence = ({ button, version }) =>
  sendEvent("modal_recurrence_click", { button, version });

/**
 * 
 * @param {string} notify
 * O atributo da notificação que o usuário clicou dentro do menu. 
 */
export const setAnalyticsNotifyClick = ({ notify }) =>
  sendEvent("notification_click", { notify });

/**
 * 
 * @param {string} profile
 * O perfil selecionado pelo usuário no modal de escolha de perfil. 
 */
export const setAnalyticsGetProfile = ({ profile }) =>
  sendEvent("select_profile", { profile });

/**
 *  Evento de novo cadastro
 */
export const setAnalyticsNewRegister = () =>
  sendEvent("new_register", { description: "Novo Cadastro - Afinando o Cérebro" });

/**
 * 
 * @param {*} name
 * Jogo clicado em jogos recomendados
 */
export const setAnalyticsRecomendedGameWeek = ({ name }) =>
  sendEvent("recommended_game_click", { game_name: name });

/**
 * @param {string} medalName
 * O nome da medalha nova que o usuário ganhou.
 */
export const setAnalyticsNewMedalView = (medalName="") =>
  sendEvent("medal_view", { description: "New Medal View", medal_name: medalName });

/**
 * @param {number} id 
 * id da medalha que o usuário clicou
 */
export const setAnalyticsNewMedalClick = (id) =>
  sendEvent("medal_click", { description: "Click Medal My Conquest", medal_id: id });
/**
 * evento de quando é clicado no tour guiado
 */
export const setAnalyticsTourPDFClick = () =>
  sendEvent("tour_pdf_download", { description: "Download Tour PDF in Modal" });

/**
 * 
 * @param {string} name
 * Nome da notificação que o usuário clicou no pushnotification.
 */
export const setAnalyticsDeviceOpenNotify = ({ name }) =>
  sendEvent("push_notify_click", { name });
/**
 * 
 * @param {string} name
 * É acionado quando o modal de limite de jogadas é clicado, e o nome é o botão clicado (ex: "Jogar Amanhã", "Assinar Plano").
 */
export const setAnalyticsClickModalLimitFree = ({ name }) =>
  sendEvent("modal_limit_free_click", { name });

/**
 * Evento de visualização do modal de limite de jogadas, é acionado quando o modal é aberto.
 */
export const setAnalyticsViewModalLimitFree = () =>
  sendEvent("modal_limit_free_view", { description: "Visualizou Modal Limit Free" });

/**
 * Evento de fechamento do modal global, é acionado quando o modal é fechado, e o target é o nome do modal fechado
 */
export const setAnalyticsCloseModalGlobal = ({ target }) =>
  sendEvent("close_modal_global", { target });

/**
 * @param {string} target
 * Evento principal da lojinha, o target é um nome composto que envia diversos dados por evento.
 */
export const setAnalyticsShopExchange = ({ target }) =>
  sendEvent("shop_exchange_click", { target });

/**
 * 
 * @param {string} target
 * Evento de clique geral pra botões, o target é um nome composto que envia diversos dados por evento.
 */
export const setAnalyticsButtonClick = ({ target }) =>
  sendEvent("button_click", { target });

/**
 * @param {string} target 
 * Evento geral de clique em banner, o target é um nome composto que envia diversos dados por evento.
 */
export const setAnalyticsBannerClick = ({ target }) =>
  sendEvent("banner_click", { target });


export const setAnalyticsClickDashCardMyPanelMoreInfo = () =>
  sendEvent("my_panel_more_info_click", { description: "Clicou no botão: mais informações" });

export const setAnalyticsClickDashCardMyPanelManageUsers = () =>
  sendEvent("my_panel_manage_users_click", { description: "Clicou no botão: gerenciar usuários" });
